// @ts-nocheck
import styled from 'styled-components';
import { getTheme } from 'settings/theme';
import type { StatelessFunctionalComponent } from 'react';

const {
  palette: { blue, greyscale },
} = getTheme();
const SelectedProgramCardWrapper: StatelessFunctionalComponent<any> = styled.div`
  background: ${blue.mysticLight};
  border-radius: 0.4rem;
  display: flex;
  padding: 0.8rem;
  margin-bottom: 0.2rem;

  :last-child {
    margin-bottom: 2.4rem;
  }

  .selected-program-card {
    &__logo {
      border-radius: 50%;
      height: 4.8rem;
      margin-right: 0.8rem;
      object-fit: cover;
      width: 4.8rem;
    }

    &__text-container {
      color: ${greyscale.outerSpace};
      display: flex;
      flex-direction: column;
      font-size: 1.6rem;
      justify-content: space-around;
      line-height: 2rem;
    }
  }
`;
export default SelectedProgramCardWrapper;
